import React from 'react';
import { OnboardingOutOfPossession } from '../../../services/aiIntelligenceService';

const PHILOSOPHIES = [
  { value: 'high-press', label: 'High Press', description: 'Win the ball back as high up the pitch as possible' },
  { value: 'mid-block', label: 'Mid Block', description: 'Compact shape in the middle third, press selectively' },
  { value: 'low-block', label: 'Low Block', description: 'Deep defensive shape, protect the goal' },
  { value: 'gegenpressing', label: 'Gegenpressing', description: 'Immediate counter-press after losing possession' },
  { value: 'zonal', label: 'Zonal Marking', description: 'Defend space rather than individual players' },
];

const DEFENSIVE_STRUCTURES = [
  { value: 'flat-back-four', label: 'Flat Back Four', description: 'Defenders in a line, offside trap' },
  { value: 'back-three', label: 'Back Three', description: 'Three centre-backs with wing-backs' },
  { value: 'man-marking', label: 'Man Marking', description: 'Each player tracks an opponent' },
  { value: 'hybrid', label: 'Hybrid', description: 'Mix of zonal and man-marking' },
];

const PRESSING_APPROACHES = [
  { value: 'aggressive', label: 'Aggressive', description: 'Press immediately on loss of possession' },
  { value: 'selective', label: 'Selective', description: 'Press only in certain areas or triggers' },
  { value: 'passive', label: 'Passive', description: 'Drop into shape and wait for mistakes' },
  { value: 'trap-based', label: 'Trap-Based', description: 'Force play into areas then press as a unit' },
];

interface OutOfPossessionStepProps {
  data: OnboardingOutOfPossession;
  onChange: (data: OnboardingOutOfPossession) => void;
}

export function OutOfPossessionStep({ data, onChange }: OutOfPossessionStepProps) {
  return (
    <div>
      <h2 className="text-xl font-bold text-gray-900 mb-2">Out of Possession</h2>
      <p className="text-sm text-gray-600 mb-6">
        How does your team defend and win the ball back?
      </p>

      {/* Philosophy */}
      <div className="mb-6">
        <label className="block text-sm font-medium text-gray-700 mb-3">
          Defensive Philosophy <span className="text-red-500">*</span>
        </label>
        <div className="grid grid-cols-1 sm:grid-cols-2 gap-2">
          {PHILOSOPHIES.map((item) => (
            <button
              key={item.value}
              type="button"
              onClick={() => onChange({ ...data, philosophy: item.value })}
              className={`text-left p-3 rounded-lg border-2 transition-all min-h-[44px] ${
                data.philosophy === item.value
                  ? 'border-blue-500 bg-blue-50'
                  : 'border-gray-200 hover:border-gray-300'
              }`}
            >
              <span className="text-sm font-medium text-gray-900">{item.label}</span>
              <span className="block text-xs text-gray-500 mt-0.5">{item.description}</span>
            </button>
          ))}
        </div>
      </div>

      {/* Defensive Structure */}
      <div className="mb-6">
        <label className="block text-sm font-medium text-gray-700 mb-3">
          Defensive Structure <span className="text-red-500">*</span>
        </label>
        <div className="grid grid-cols-1 sm:grid-cols-2 gap-2">
          {DEFENSIVE_STRUCTURES.map((item) => (
            <button
              key={item.value}
              type="button"
              onClick={() => onChange({ ...data, defensiveStructure: item.value })}
              className={`text-left p-3 rounded-lg border-2 transition-all min-h-[44px] ${
                data.defensiveStructure === item.value
                  ? 'border-blue-500 bg-blue-50'
                  : 'border-gray-200 hover:border-gray-300'
              }`}
            >
              <span className="text-sm font-medium text-gray-900">{item.label}</span>
              <span className="block text-xs text-gray-500 mt-0.5">{item.description}</span>
            </button>
          ))}
        </div>
      </div>

      {/* Pressing Approach */}
      <div>
        <label className="block text-sm font-medium text-gray-700 mb-3">
          Pressing Approach <span className="text-red-500">*</span>
        </label>
        <div className="grid grid-cols-1 sm:grid-cols-2 gap-2">
          {PRESSING_APPROACHES.map((item) => (
            <button
              key={item.value}
              type="button"
              onClick={() => onChange({ ...data, pressingApproach: item.value })}
              className={`text-left p-3 rounded-lg border-2 transition-all min-h-[44px] ${
                data.pressingApproach === item.value
                  ? 'border-blue-500 bg-blue-50'
                  : 'border-gray-200 hover:border-gray-300'
              }`}
            >
              <span className="text-sm font-medium text-gray-900">{item.label}</span>
              <span className="block text-xs text-gray-500 mt-0.5">{item.description}</span>
            </button>
          ))}
        </div>
      </div>
    </div>
  );
}
